module.exports = __webpack_public_path__ + "media/images/bg/mosaic/origami-lightblue-f16ba7988e30b73e4ef2a1717c4b7cec.svg";